define(["backbone", "configuration/properties", "messaging/messenger"], function (
  Backbone,
  Properties,
  Messenger,
) {
  "use strict";

  const AiSummarizeResponseModel = {};

  AiSummarizeResponseModel.responseSummarize = Backbone.Model.extend({
    defaults: {
      response: "",
      targetLocaleId: 0,
    },
    url: function () {
      const kbId = Messenger.reqres.request("active:kb");
      return `${Properties.rootURL}/${kbId}/intents/response/summarize`;
    },
  });
  return AiSummarizeResponseModel;
});
